// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 617) return "static/chunks/617-40d08f56788732d8.js";
	if (chunkId === 5927) return "static/chunks/5927-c9b2658dfcab2598.js";
	if (chunkId === 7969) return "static/chunks/7969-e0992e73ae5e8253.js";
	if (chunkId === 7644) return "static/chunks/7644-eba7a7c19080e524.js";
	if (chunkId === 2615) return "static/chunks/2615-3dc2478e9dad2f26.js";
	if (chunkId === 1153) return "static/chunks/1153-680902f8f9a88f5c.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2826":"36c7393a","7776":"477d4af2","9268":"aaea2bcf","9944":"c2d89bc4"}[chunkId] || chunkId) + "." + {"1000":"8c356515305c2f20","1619":"2053a8ed875558df","2242":"56b7ec6b145cbc63","2826":"47ea5ec4903c5882","7776":"2760510c8f814c6b","8097":"5b4d1109d711ade3","9268":"5a58e3b5534096cf","9944":"0f5018687992c93d"}[chunkId] + ".js";
};